import { FormStore, FieldDesc } from '../FormStore';
import { BaseField } from './BaseField';

export interface CharacterFieldDesc extends FieldDesc  {
  bizType?: string
  type?: string
}

/**
 * 特征组field
 * 特征值初始化
 * 保存特征类型
 */
export class CharacterField extends BaseField {
  type: string
  constructor(fieldDesc: CharacterFieldDesc, formStore: FormStore) {
    super(fieldDesc, formStore)
    this.type = fieldDesc.bizType || fieldDesc.type || ''
    if (!fieldDesc.defaultValue) this.defaultValue = {}
  }

}
